import gridimg1 from "../assest/images/gridimg1.png";
import gridimg2 from "../assest/images/gridimg2.png";
import gridimg3 from "../assest/images/gridimg3.png";
import gridimg4 from "../assest/images/gridimg4.png";
import ContentLoader from 'react-content-loader';
import helper, { getLinkNameByLang, getSlugByLang, getSlugNameByLang } from "../common/Helper";
import ListLoading from "./ListLoading";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";


const VacationDestination = ({ nextLocations,
    nextTheme, isLoading, title = "Where do you want to enjoy your next vacation?",
    isNextVacationLoading, nextLocationNextPageUrl, onClickLoadMore
}) => {

    const navigate = useNavigate();
    const user = useSelector((state) => state.user);
    const slugField = getLinkNameByLang(user?.language)
    const slugLang = getSlugByLang(user?.language)



    // const renderHtml = (record, index) => {
    //     switch (index % 5) {
    //         case 0:
    //             return (
    //                 <Link className="imgGridBox rowSpan2" to={'/location' + record?.location?.link} key={index}>
    //                     {/* <div className="imgGridBox rowSpan2" key={index} > */}
    //                     <img src={helper.S3Url + '/' + helper.locationImageDir + '/' + record?.location?.image}
    //                         alt="gridimg1"
    //                         onError={(e) => {
    //                             e.target.onerror = null;
    //                             e.target.src = gridimg1
    //                         }}
    //                     />

    //                     <div className="textBox">
    //                         <h5>{record?.location?.name}</h5>
    //                         <p>{record?.product_count} {record?.product_count > 1 ? 'Tours' : 'Tour'}</p>
    //                     </div>
    //                     {/* </div> */}
    //                 </Link>
    //             );
    //         case 1:
    //             return (
    //                 <Link className="imgGridBox length300" to={'/location' + record?.location?.link} key={index}>
    //                     {/* <div className="imgGridBox length300" key={index}> */}
    //                     <img src={helper.S3Url + '/' + helper.locationImageDir + '/thumbnail/' + record?.location?.image}
    //                         alt="gridimg2"
    //                         onError={(e) => {
    //                             e.target.onerror = null;
    //                             e.target.src = gridimg2
    //                         }}
    //                     />
    //                     <div className="textBox">
    //                         <h5>{record?.location?.name}</h5>
    //                         <p>{record?.product_count} {record?.product_count > 1 ? 'Tours' : 'Tour'}</p>
    //                     </div>
    //                     {/* </div> */}
    //                 </Link>
    //             );
    //         case 2:
    //             return (
    //                 <Link className="imgGridBox colSpan2" to={'/location' + record?.location?.link} key={index}>
    //                     {/* <div className="imgGridBox colSpan2" key={index}> */}
    //                     <img src={helper.S3Url + '/' + helper.locationImageDir + '/thumbnail/' + record?.location?.image}
    //                         alt="gridimg3"
    //                         onError={(e) => {
    //                             e.target.onerror = null;
    //                             e.target.src = gridimg3
    //                         }}
    //                     />
    //                     <div className="textBox">
    //                         <h5>{record?.location?.name}</h5>
    //                         <p>{record?.product_count} {record?.product_count > 1 ? 'Tours' : 'Tour'}</p>
    //                     </div>
    //                     {/* </div> */}
    //                 </Link>
    //             );
    //         case 3:
    //             return (
    //                 <Link className="imgGridBox colSpan2 colSpanmobile" to={'/location' + record?.location?.link} key={index}>
    //                     {/* <div className="imgGridBox colSpan2 colSpanmobile" key={index}> */}
    //                     <img src={record?.location?.name ? (helper.S3Url + '/' + helper.locationImageDir + '/thumbnail/' + record?.location?.image) : gridimg4}
    //                         alt="gridimg4"
    //                         onError={(e) => {
    //                             e.target.onerror = null;
    //                             e.target.src = gridimg4
    //                         }}
    //                     />
    //                     <div className="textBox">
    //                         <h5>{record?.location?.name}</h5>
    //                         <p>{record?.product_count} {record?.product_count > 1 ? 'Tours' : 'Tour'}</p>
    //                     </div>
    //                     {/* </div> */}
    //                 </Link>
    //             );
    //         case 4:
    //             return (
    //                 <Link className="imgGridBox length300" to={'/location' + record?.location?.link} key={index}>
    //                     {/* <div className="imgGridBox length300" key={index}> */}
    //                     <img src={record?.location?.name ? (helper.S3Url + '/' + helper.locationImageDir + '/thumbnail/' + record?.location?.image) : gridimg4}
    //                         alt="gridimg4"
    //                         onError={(e) => {
    //                             e.target.onerror = null;
    //                             e.target.src = gridimg4
    //                         }}
    //                     />
    //                     <div className="textBox">
    //                         <h5>{record?.location?.name}</h5>
    //                         <p>{record.product_count} {record?.product_count > 1 ? 'Tours' : 'Tour'}</p>
    //                     </div>
    //                     {/* </div> */}
    //                 </Link>
    //             );
    //         default:
    //             return <></>;
    //     }
    // };


    const renderHtml = (record, index) => {
        switch (index % 6) {
            case 0:
                return (
                    <Link className="imgGridBox length300"
                        // to={'/location' + record?.location?.link} 
                        to={(slugLang ? ('/' + slugLang) : '') + '/location' + record?.location?.[slugField]}
                        key={index}>

                        <img src={helper.S3Url + '/' + helper.locationImageDir + '/' + record?.location?.listing_image
                        }
                            alt="gridimg1"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = gridimg1
                            }}
                        />

                        <div className="textBox">
                            <h5>{record?.location?.name}</h5>
                            <p>{record?.product_count} {record?.product_count > 1 ? 'Tours' : 'Tour'}</p>
                        </div>

                    </Link>
                );
            case 1:
                return (
                    <Link className="imgGridBox colSpan2 length300"
                        // to={'/location' + record?.location?.link}
                        to={(slugLang ? ('/' + slugLang) : '') + '/location' + record?.location?.[slugField]}
                        key={index}>
                        <img src={helper.S3Url + '/' + helper.locationImageDir + '/' + record?.location?.image}
                            alt="gridimg2"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = gridimg2
                            }}
                        />
                        <div className="textBox">
                            <h5>{record?.location?.name}</h5>
                            <p>{record?.product_count} {record?.product_count > 1 ? 'Tours' : 'Tour'}</p>
                        </div>
                    </Link>
                );
            case 2:
                return (
                    <Link className="imgGridBox length300"
                        // to={'/location' + record?.location?.link}
                        to={(slugLang ? ('/' + slugLang) : '') + '/location' + record?.location?.[slugField]}
                        key={index}>
                        <img src={helper.S3Url + '/' + helper.locationImageDir + '/' + record?.location?.listing_image}
                            alt="gridimg3"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = gridimg3
                            }}
                        />
                        <div className="textBox">
                            <h5>{record?.location?.name}</h5>
                            <p>{record?.product_count} {record?.product_count > 1 ? 'Tours' : 'Tour'}</p>
                        </div>
                    </Link>
                );
            case 3:
                return (
                    <Link className="imgGridBox colSpan2 length300"
                        // to={'/location' + record?.location?.link}
                        to={(slugLang ? ('/' + slugLang) : '') + '/location' + record?.location?.[slugField]}
                        key={index}>
                        {/* <div className="imgGridBox colSpan2 colSpanmobile" key={index}> */}
                        <img src={record?.location?.name ? (helper.S3Url + '/' + helper.locationImageDir + '/' + record?.location?.image) : gridimg4}
                            alt="gridimg4"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = gridimg4
                            }}
                        />
                        <div className="textBox">
                            <h5>{record?.location?.name}</h5>
                            <p>{record?.product_count} {record?.product_count > 1 ? 'Tours' : 'Tour'}</p>
                        </div>
                        {/* </div> */}
                    </Link>
                );
            case 4:
                return (
                    <Link className="imgGridBox colSpanmobile length300"
                        // to={'/location' + record?.location?.link} 
                        to={(slugLang ? ('/' + slugLang) : '') + '/location' + record?.location?.[slugField]}
                        key={index}>

                        <img src={record?.location?.name ? (helper.S3Url + '/' + helper.locationImageDir + '/' + record?.location?.listing_image) : gridimg4}
                            alt="gridimg4"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = gridimg4
                            }}
                        />
                        <div className="textBox">
                            <h5>{record?.location?.name}</h5>
                            <p>{record.product_count} {record?.product_count > 1 ? 'Tours' : 'Tour'}</p>
                        </div>
                    </Link>
                );
            case 5:
                return (
                    <Link className="imgGridBox length300"
                        // to={'/location' + record?.location?.link} 
                        to={(slugLang ? ('/' + slugLang) : '') + '/location' + record?.location?.[slugField]}
                        key={index}>

                        <img src={record?.location?.name ? (helper.S3Url + '/' + helper.locationImageDir + '/' + record?.location?.listing_image) : gridimg4}
                            alt="gridimg4"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = gridimg4
                            }}
                        />
                        <div className="textBox">
                            <h5>{record?.location?.name}</h5>
                            <p>{record.product_count} {record?.product_count > 1 ? 'Tours' : 'Tour'}</p>
                        </div>
                    </Link>
                );
            default:
                return <></>;
        }
    };

    const renderHtmlMobile = (record, index) => {
        switch (index % 6) {
            case 0:
                return (
                    <Link className="imgGridBox length300"
                        // to={'/location' + record?.location?.link} 
                        to={(slugLang ? ('/' + slugLang) : '') + '/location' + record?.location?.[slugField]}
                        key={index}>

                        <img src={helper.S3Url + '/' + helper.locationImageDir + '/' + record?.location?.listing_image}
                            alt="gridimg1"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = gridimg1
                            }}
                        />

                        <div className="textBox">
                            <h5>{record?.location?.name}</h5>
                            <p>{record?.product_count} {record?.product_count > 1 ? 'Tours' : 'Tour'}</p>
                        </div>

                    </Link>
                );
            case 1:
                return (
                    <Link className="imgGridBox length300"
                        // to={'/location' + record?.location?.link} 
                        to={(slugLang ? ('/' + slugLang) : '') + '/location' + record?.location?.[slugField]}
                        key={index}>
                        <img src={helper.S3Url + '/' + helper.locationImageDir + '/' + record?.location?.listing_image}
                            alt="gridimg2"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = gridimg2
                            }}
                        />
                        <div className="textBox">
                            <h5>{record?.location?.name}</h5>
                            <p>{record?.product_count} {record?.product_count > 1 ? 'Tours' : 'Tour'}</p>
                        </div>
                    </Link>
                );
            case 2:
                return (
                    <Link className="imgGridBox colSpan2 length300"
                        // to={'/location' + record?.location?.link}
                        to={(slugLang ? ('/' + slugLang) : '') + '/location' + record?.location?.[slugField]}
                        key={index}>
                        <img src={helper.S3Url + '/' + helper.locationImageDir + '/' + record?.location?.image}
                            alt="gridimg3"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = gridimg3
                            }}
                        />
                        <div className="textBox">
                            <h5>{record?.location?.name}</h5>
                            <p>{record?.product_count} {record?.product_count > 1 ? 'Tours' : 'Tour'}</p>
                        </div>
                    </Link>
                );
            case 3:
                return (
                    <Link className="imgGridBox colSpanmobile length300"
                        // to={'/location' + record?.location?.link} 
                        to={(slugLang ? ('/' + slugLang) : '') + '/location' + record?.location?.[slugField]}
                        key={index}>
                        {/* <div className="imgGridBox colSpan2 colSpanmobile" key={index}> */}
                        <img src={record?.location?.name ? (helper.S3Url + '/' + helper.locationImageDir + '/' + record?.location?.listing_image) : gridimg4}
                            alt="gridimg4"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = gridimg4
                            }}
                        />
                        <div className="textBox">
                            <h5>{record?.location?.name}</h5>
                            <p>{record?.product_count} {record?.product_count > 1 ? 'Tours' : 'Tour'}</p>
                        </div>
                        {/* </div> */}
                    </Link>
                );
            case 4:
                return (
                    <Link className="imgGridBox length300"
                        // to={'/location' + record?.location?.link}
                        to={(slugLang ? ('/' + slugLang) : '') + '/location' + record?.location?.[slugField]}
                        key={index}>

                        <img src={record?.location?.name ? (helper.S3Url + '/' + helper.locationImageDir + '/' + record?.location?.listing_image) : gridimg4}
                            alt="gridimg4"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = gridimg4
                            }}
                        />
                        <div className="textBox">
                            <h5>{record?.location?.name}</h5>
                            <p>{record.product_count} {record?.product_count > 1 ? 'Tours' : 'Tour'}</p>
                        </div>
                    </Link>
                );
            case 5:
                return (
                    <Link className="imgGridBox colSpan2 length300"
                        // to={'/location' + record?.location?.link} 
                        to={(slugLang ? ('/' + slugLang) : '') + '/location' + record?.location?.[slugField]}
                        key={index}>

                        <img src={record?.location?.name ? (helper.S3Url + '/' + helper.locationImageDir + '/' + record?.location?.image) : gridimg4}
                            alt="gridimg4"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = gridimg4
                            }}
                        />
                        <div className="textBox">
                            <h5>{record?.location?.name}</h5>
                            <p>{record.product_count} {record?.product_count > 1 ? 'Tours' : 'Tour'}</p>
                        </div>
                    </Link>
                );
            default:
                return <></>;
        }
    };





    return (
        <section className="gallery">
            <div className="galleryPart">
                <div className="container">
                    <div className="sectionTitle">
                        <h3>{title}</h3>
                    </div>
                    {
                        !isLoading ?
                            <>
                                <div className="desktop">
                                    <div className="galleryBox">
                                        {
                                            nextLocations.map((rec, ind) => {
                                                return renderHtml(rec, ind)
                                            })
                                        }
                                    </div>
                                </div>
                                <div className="mobile">
                                    <div className="galleryBox">
                                        {
                                            nextLocations.map((rec, ind) => {
                                                return renderHtmlMobile(rec, ind)
                                            })
                                        }
                                    </div>
                                </div>
                                {/* <div className="showMore">
                                    <button className="btn showMoreBtn">Show more <i className="fa-solid fa-chevron-right"></i></button>
                                </div> */}
                                {
                                    isNextVacationLoading ? <ListLoading /> :
                                        nextLocations.length > 0 && nextLocationNextPageUrl &&

                                        <div className="showMore">
                                            <button
                                                className="btn showMoreBtn"
                                                onClick={() => onClickLoadMore('nextVacation', nextLocationNextPageUrl.split('=')[1])}

                                            >Show more <i className="fa-solid fa-chevron-right"></i></button>
                                        </div>
                                }
                            </>
                            :
                            <ContentLoader
                                backgroundColor="#e0e0d9"
                                foregroundColor="#d6d6d0"
                                viewBox={`0 0 ${window.innerWidth} 540`}
                                width="100%"
                                height="540"
                            >
                                <rect x="0" y="0" rx="24" ry="24" width="100%" height="540" />
                            </ContentLoader>
                    }

                </div>
            </div>
        </section>
    )
}
export default VacationDestination;